import { useLocation } from "react-router-dom";
import InfiniteScroll from "../../Components/Functionality/InfiniteScrollList";
import Container from "../../Components/UI/Container";
import { useDebatesStatusStore, useWorkspaceStore } from "../../Context/store";
import {
  useDebateReadMutation,
  useGetPublicDebateList,
} from "../../Web-Hooks/Debate/use-debate";
import Posts from "../Posts/Posts";
import { useUserStore } from "../../Context/store";
import { useEffect } from "react";

const PublicHome = () => {
  const location = useLocation();
  const { pathname } = location;
  const { selectedWorkspace } = useWorkspaceStore();
  const { user } = useUserStore();
  const QueryKey = [
    "public-feed-workspace",
    user?.userId,
    selectedWorkspace?.workSpaceId,
  ];

  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useGetPublicDebateList(user?.userId, selectedWorkspace?.workSpaceId);
  const { mutateAsync: readStatus, isPending } = useDebateReadMutation();
  const { allForumStatus } = useDebatesStatusStore();

  const hasNewDebates =
    isLoading || isPending ? false : allForumStatus?.publicFeed;

  useEffect(() => {
    readStatus({
      userId: user?.userId,
      workspaceId: selectedWorkspace?.workSpaceId,
      sectionType: "public",
    });
  }, [readStatus, user?.userId, selectedWorkspace?.workSpaceId]);

  const handleRefetch = async() => {
    readStatus({
      userId: user?.userId,
      workspaceId: selectedWorkspace?.workSpaceId,
      sectionType: "public",
    });
    const response = await refetch();
    return response;
  };

  return (
    <Container>
      {/* Title */}
      <InfiniteScroll
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
        hasNewData={hasNewDebates}
        refetch={handleRefetch}
        queryKey={QueryKey}
      >
        <Posts
          apiType={pathname}
          user={user}
          isLoading={isLoading && !isFetchingNextPage}
          AllDebates={data?.pages?.flatMap((page) => page.debateList)} // Combine all pages
        />
      </InfiniteScroll>
    </Container>
  );
};

export default PublicHome;
